/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AcceptInvite } from '../models/AcceptInvite';
import type { BatchQueryFollowStatus } from '../models/BatchQueryFollowStatus';
import type { BatchQueryFollowStatusRet } from '../models/BatchQueryFollowStatusRet';
import type { FollowRet } from '../models/FollowRet';
import type { Friend } from '../models/Friend';
import type { FriendList } from '../models/FriendList';
import type { GameAchievementDto } from '../models/GameAchievementDto';
import type { SendInvite } from '../models/SendInvite';
import type { SettingDto } from '../models/SettingDto';
import type { TimeTrackingDto } from '../models/TimeTrackingDto';
import type { UpdateSettingDto } from '../models/UpdateSettingDto';
import type { UpdateUserDto } from '../models/UpdateUserDto';
import type { UploadContact } from '../models/UploadContact';
import type { UserAchievementResponse } from '../models/UserAchievementResponse';
import type { UserDto } from '../models/UserDto';
import type { UserGameInfoDto } from '../models/UserGameInfoDto';
import type { UserGamesInfoDto } from '../models/UserGamesInfoDto';
import type { UserInfoDto } from '../models/UserInfoDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class UsersService {
    /**
     * @param requestBody
     * @returns BatchQueryFollowStatusRet
     * @throws ApiError
     */
    public static queryFollowStatus(
        requestBody: BatchQueryFollowStatus,
    ): CancelablePromise<BatchQueryFollowStatusRet> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/users/followStatus',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param ids
     * @returns UserDto
     * @throws ApiError
     */
    public static getUserByIds(
        ids: Array<number>,
    ): CancelablePromise<Array<UserDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/users',
            query: {
                'ids': ids,
            },
        });
    }
    /**
     * @param userId
     * @returns UserDto
     * @throws ApiError
     */
    public static getUserById(
        userId: number,
    ): CancelablePromise<UserDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/users/{userId}/basic',
            path: {
                'userId': userId,
            },
        });
    }
    /**
     * @param userId
     * @returns UserInfoDto
     * @throws ApiError
     */
    public static getUserInfo(
        userId: number,
    ): CancelablePromise<UserInfoDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/users/{userId}',
            path: {
                'userId': userId,
            },
        });
    }
    /**
     * @param userId
     * @returns FollowRet
     * @throws ApiError
     */
    public static follow(
        userId: number,
    ): CancelablePromise<FollowRet> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/users/{userId}/follow',
            path: {
                'userId': userId,
            },
        });
    }
    /**
     * @param userId
     * @returns FollowRet
     * @throws ApiError
     */
    public static unFollow(
        userId: number,
    ): CancelablePromise<FollowRet> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/users/{userId}/follow',
            path: {
                'userId': userId,
            },
        });
    }
    /**
     * @param userId
     * @returns FollowRet
     * @throws ApiError
     */
    public static removeFollower(
        userId: number,
    ): CancelablePromise<FollowRet> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/users/{userId}/follower',
            path: {
                'userId': userId,
            },
        });
    }
    /**
     * @param userId
     * @param take take is the number of items to take.
     * @param cursorId cursorId is the id of the last item of the previous page.
     * @returns FriendList
     * @throws ApiError
     */
    public static followers(
        userId: number,
        take: number,
        cursorId?: number,
    ): CancelablePromise<FriendList> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/users/{userId}/followers',
            path: {
                'userId': userId,
            },
            query: {
                'cursorId': cursorId,
                'take': take,
            },
        });
    }
    /**
     * @param userId
     * @param take take is the number of items to take.
     * @param cursorId cursorId is the id of the last item of the previous page.
     * @returns FriendList
     * @throws ApiError
     */
    public static followings(
        userId: number,
        take: number,
        cursorId?: number,
    ): CancelablePromise<FriendList> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/users/{userId}/followings',
            path: {
                'userId': userId,
            },
            query: {
                'cursorId': cursorId,
                'take': take,
            },
        });
    }
    /**
     * @param userId
     * @param take take is the number of items to take.
     * @param cursorId cursorId is the id of the last item of the previous page.
     * @returns FriendList
     * @throws ApiError
     */
    public static friends(
        userId: number,
        take: number,
        cursorId?: number,
    ): CancelablePromise<FriendList> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/users/{userId}/friends',
            path: {
                'userId': userId,
            },
            query: {
                'cursorId': cursorId,
                'take': take,
            },
        });
    }
    /**
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    public static uploadContacts(
        requestBody: UploadContact,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/users/contacts',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns Friend
     * @throws ApiError
     */
    public static followSuggestions(): CancelablePromise<Array<Friend>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/users/suggestions',
        });
    }
    /**
     * @param requestBody
     * @returns string
     * @throws ApiError
     */
    public static sendInviteLink(
        requestBody: SendInvite,
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/users/invite/send',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns string
     * @throws ApiError
     */
    public static acceptInviteLink(
        requestBody: AcceptInvite,
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/users/invite/accept',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns UserDto
     * @throws ApiError
     */
    public static getMyInfo(): CancelablePromise<UserDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/users/me',
        });
    }

    /**
     * @param requestBody
     * @returns UserDto
     * @throws ApiError
     */
    public static updateMyInfo(
        requestBody: UpdateUserDto,
    ): CancelablePromise<UserDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/users/me',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns SettingDto
     * @throws ApiError
     */
    public static getMySettings(): CancelablePromise<SettingDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/users/me/settings',
        });
    }
    /**
     * @param requestBody
     * @returns SettingDto
     * @throws ApiError
     */
    public static updateMySettings(
        requestBody: UpdateSettingDto,
    ): CancelablePromise<SettingDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/users/me/settings',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns any
     * @throws ApiError
     */
    public static time(
        requestBody: TimeTrackingDto,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/users/me/time',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns any
     * @throws ApiError
     */
    public static logout(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/users/logout',
        });
    }
    /**
     * @param userId
     * @returns UserGamesInfoDto
     * @throws ApiError
     */
    public static getGamesInfo(
        userId: number,
    ): CancelablePromise<UserGamesInfoDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/users/{userId}/games',
            path: {
                'userId': userId,
            },
        });
    }
    /**
     * @param userId
     * @param gameId
     * @returns UserGameInfoDto
     * @throws ApiError
     */
    public static getGameInfo(
        userId: number,
        gameId: number,
    ): CancelablePromise<UserGameInfoDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/users/{userId}/games/{gameId}',
            path: {
                'userId': userId,
                'gameId': gameId,
            },
        });
    }
    /**
     * @param userId
     * @returns UserAchievementResponse
     * @throws ApiError
     */
    public static getUserAchievements(
        userId: number,
    ): CancelablePromise<UserAchievementResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/users/{userId}/achievements',
            path: {
                'userId': userId,
            },
        });
    }
    /**
     * @param userId
     * @param gameId
     * @returns GameAchievementDto
     * @throws ApiError
     */
    public static getAchievementByGame(
        userId: number,
        gameId: number,
    ): CancelablePromise<GameAchievementDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/users/{userId}/achievements/games/{gameId}',
            path: {
                'userId': userId,
                'gameId': gameId,
            },
        });
    }
}
